<div class="whatsappicon">
    <a href="https://wa.me/573218465585">
        <img src="../../../assets/images/whatsapp.png" alt="WhatsApp" height="65rem" width="65rem">
    </a>   
</div>

